module.exports = __webpack_public_path__ + "img/tira-larga.0698a543.png";